/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  CircularProgress, // Import CircularProgress for the loader
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import RangeDatePicker from "../../IotComponent/AppDatePicker/AppDatePicker";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import {
  AllGpsReportResponse,
  AllGpsReportResponseDownload,
} from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import { CSVLink } from "react-csv";
import { blue } from "@mui/material/colors";

const GpsReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalCount, setTotalCount] = useState<any>();
  const [gpsReport, setGpsReport] = useState<AllGpsReportResponse | null>(null);
  const [gpsReportDownload, setGpsReportDownload] =
    useState<AllGpsReportResponseDownload | null>(null);
    const [userRole, setUserRole] = useState<string | null>(null);

  const [downloadpage, setDownloadPage] = useState(1);
  const [downloadrowsPerPage, setDownloadRowsPerPage] = useState(50000);
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [loading, setLoading] = useState(false); // Add loading state
  const pageRange = 5;
  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  // Dummy data for tables
  useEffect(()=>{
    const role = localStorage.getItem("authority");
    setUserRole(role);
  },[])
  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const formatTime = (dateTime: string) => {
    const formattedDateTime = dateTime.replace("T", " "); // Replace "T" with a space
    const date = new Date(formattedDateTime); // Convert to Date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0"); // Format hours to 2 digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Format minutes to 2 digits
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Format seconds to 2 digits

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // Return date and time in YYYY-MM-DD HH:MM:SS format
  };

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleDateChange = (dates: [Date | null, Date | null]) => {
    // Handle date range change

    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };

  useEffect(() => {
    const fetchDriverBehaviorReport = async () => {
      setLoading(true); // Set loading to true when fetching starts
      try {
        const data: AllGpsReportResponse =
          await FleetDashboardOverviewApi.api.getGpsReport(
            searchValInput,
            startDate,
            endDate,
            page + 1,
            rowsPerPage
          );

        setGpsReport(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      } finally {
        setLoading(false); // Set loading to false when fetching ends
      }
    };
    fetchDriverBehaviorReport();
  }, [searchValInput, startDate, endDate, page + 1]);

  useEffect(() => {
    const fetchDriverBehaviorReportDownload = async () => {
      setLoading(true); // Set loading to true when fetching starts
      try {
        const data: AllGpsReportResponseDownload =
          await FleetDashboardOverviewApi.api.getGpsReportDownload(
            searchValInput,
            startDate,
            endDate,
            downloadpage,
            downloadrowsPerPage
          );
          
        const modifiedData = {
          ...data,
          data: {
            ...data.data,
            tracking_data: data.data.tracking_data.map((item) => ({
              ...item,
              createdTime: item.createdTime.split('+')[0], 
            })),
          },
        };
  
        setGpsReportDownload(modifiedData);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      } finally {
        setLoading(false); // Set loading to false when fetching ends
      }
    };
    fetchDriverBehaviorReportDownload();
  }, [searchValInput, downloadrowsPerPage, startDate, endDate, downloadpage]);

  const gpsReportSummaryButton = [
    { label: "Vehicle No.", key: "qrCode" },
    { label: "Latitude", key: "latitude" },
    { label: "Longitude", key: "longitude" },
    { label: "LockStatus", key: "lockStatus" },
    { label: "Speed", key: "speed" },
    { label: "Distance", key: "Distance" },
    { label: "Increamental Distance	", key: "Increamental_Distance" },
    { label: "Created Time", key: "createdTime" },
  ];

  return (
    <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between ">
          <Grid item md={4}>
            <div className="flex ml-4">
              <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                GPS Report{" "}
              </h2>
            </div>
          </Grid>
          <Grid item md={8}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
                <div className="mr-3">
                  <TextField
                    placeholder="EB Number & User ID"
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(search: any) =>
                      setSearchValInput(search.target.value)
                    }
                    value={searchValInput}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={handleClearSearch}
                        >
                          <ClearIcon style={{ cursor: "pointer" }} />
                        </InputAdornment>
                      ),
                      style: { height: "40px", borderRadius: "25px" },
                    }}
                    // onKeyDown={handleKeyPress}
                  />
                </div>

                <div className="flex items-center w-[450px]">
                  <p className="mr-2 font-semibold w-auto">Date Range: </p>
                  <RangeDatePicker
                    onChange={handleDateChange}
                    maxDaysAdd={0}
                    minDaysSub={92}
                    defaultStartDate={0}
                    defaultEndDate={0}
                  />
                </div>
                {(userRole === "ROLE_FLEET_SUPER_ADMIN" || 
    userRole === "ROLE_ADMIN" || 
    userRole === "ROLE_CO_ADMIN") && ( // Ensure this condition is checked
                <div>
                  <CSVLink
                    data={gpsReportDownload?.data.tracking_data || []}
                    headers={gpsReportSummaryButton}
                    filename={`Gps_Summary_Report.csv`}
                    style={{ marginRight: "10px" }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#06B681",
                        padding: "8px 20px",
                        color: "#fff",
                        borderRadius: "25px",
                        width: "100%",
                        textTransform: "none",
                        marginLeft: "10px",
                      }}
                    >
                      Download
                    </Button>
                  </CSVLink>
                </div>
                )}
              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />
        {loading ? ( // Conditionally render loader
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "20px",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 120 }}
                  >
                    Vehicle No.
                  </TableCell>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 150 }}
                  >
                    Location
                  </TableCell>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 110 }}
                  >
                    LockStatus
                  </TableCell>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 110 }}
                  >
                    Speed
                  </TableCell>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 100 }}
                  >
                    Distance (Km)
                  </TableCell>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 100 }}
                  >
                    Increamental Distance
                  </TableCell>
                  <TableCell
                    style={tableHeaderCellStyle}
                    sx={{ minWidth: 100 }}
                  >
                    Created Time
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchValInput === "" ? (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      style={{ fontWeight: 600, color: "#A4A2A2" }}
                    >
                      Please search QR code
                    </TableCell>
                  </TableRow>
                ) : gpsReport?.data.tracking_data?.length ? (
                  gpsReport.data.tracking_data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={tableBodyCellStyle}>
                        {item.qrCode}
                      </TableCell>
                      <TableCell style={tableBodyCellStyle}>
                        <a
                          style={{ color: blue[400] }}
                          href={`https://www.google.com/maps?q=${item.latitude.toFixed(
                            6
                          )},${item.longitude.toFixed(6)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.latitude.toFixed(6)},{item.longitude.toFixed(6)}
                        </a>
                      </TableCell>
                      <TableCell style={tableBodyCellStyle}>
                        {item.lockStatus}
                      </TableCell>
                      <TableCell style={tableBodyCellStyle}>
                        {item.speed}
                      </TableCell>
                      <TableCell style={tableBodyCellStyle}>
                        {item.Distance}
                      </TableCell>
                      <TableCell style={tableBodyCellStyle}>
                        {item.Increamental_Distance}
                      </TableCell>
                      <TableCell style={tableBodyCellStyle}>
                        {formatTime(item.createdTime)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      align="center"
                      style={{ fontWeight: 600, color: "#A4A2A2" }}
                    >
                      No results found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= pageCount - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GpsReport;
